export const PT_PROFILE = "/profile";
export const PT_SIGNIN = "/signin";
export const PT_OTP = "/otp";
export const PT_REGISTER = "/register";
export const PT_ADDRESSLIST = "/addressList/:frompage";
export const PT_ADDNEWADDRESS = "/addnewaddress";
export const PT_MAP = "/map";
export const PT_COMPLETEORDERS = "/completeorder";
export const PT_PRIVACYPOLICY = "/privacypolicy";
export const PT_DAITONN = "/Daitonn";

export const PROFILE_STACK_PATHS_CONTAIN_CHECK = (pathname) => {
  let firstPart = pathname.split("/").filter(Boolean)[0];
  let paths =
    PT_PROFILE +
    PT_SIGNIN +
    PT_OTP +
    PT_DAITONN +
    PT_REGISTER +
    PT_ADDRESSLIST +
    PT_ADDNEWADDRESS +
    PT_MAP +
    PT_PRIVACYPOLICY +
    PT_COMPLETEORDERS;
  return paths.toUpperCase().includes(firstPart.toUpperCase());
};
